import moment from "moment";
import {
  getData,
  postData,
  convertPageModel,
  getFileData,
  formSend
} from './api-base.service'

export const getChannelItems = () => {
  return getData('/StudyAbroad/GetChannelItems');
}

export const getChannelList = () => {
  let result = getData('/StudyAbroad/GetChannelList');
  return result;
}

export const getChannelPageData = (model) => {
  let data = convertPageModel(model);
  let result = postData('/StudyAbroad/GetChannelPageData', data);
  return result;
}

export const getChannel = (id) => {
  let result = getData('/StudyAbroad/GetChannel', {
    id: id
  });
  return result;
}

export const saveChannel = (data) => {
  let result = postData('/StudyAbroad/SaveChannel', data);
  return result;
}

export const deleteChannel = (id) => {
  let result = getData('/StudyAbroad/DeleteChannel', {
    id: id
  });
  return result;
}

export const getChannelSAPServiceList = (channelId) => {
  let data = {
    channelId
  };
  let result = getData('/StudyAbroad/GetChannelSAPServiceList', data);
  return result;
}

export const saveChannelBottomPriceSettingList = (data) => {
  let result = postData('/StudyAbroad/SaveChannelBottomPriceSettingList', data);
  return result;
}

export const getChannelMaxCommission = () => {
  let result = getData('/StudyAbroad/GetChannelMaxCommission');
  return result;
};

export const getStudentList = (model) => {
  let data = convertPageModel(model);
  let result = postData('/StudyAbroad/GetStudentList', data);
  return result;
}

export const getStudentStudyAbroadWorkflow = (studentId) => {
  return getData('/StudyAbroad/GetStudentStudyAbroadWorkflow', {
    studentId: studentId
  });
}

export const getStudyAbroadStudent = (studentId, workflowId = null) => {
  let result = getData('/StudyAbroad/GetStudyAbroadStudent', {
    studentId,
    workflowId
  });
  return result;
}

export const getStudyAbroadWorkflowServicePageData = (model) => {
  let data = convertPageModel(model);
  let result = postData('/StudyAbroad/GetStudyAbroadWorkflowServicePageData', data);
  return result;
}

export const getSAStudentWorkflow = (id) => {
  let result = getData('/StudyAbroad/GetSAStudentWorkflow', {
    id
  });
  return result;
}

export const getSAStudentWorkflowByAccountId = (accountId) => {
  let result = getData('/StudyAbroad/GetSAStudentWorkflowByAccountId', {
    accountId
  });
  return result;
}

export const getSAStudentWorkflowServiceList = (studentId) => {
  let result = getData('/StudyAbroad/GetSAStudentWorkflowServiceList', {
    studentId
  });
  return result;
}

export const getSAStudentWorkflowService = (wsId) => {
  let result = getData('/StudyAbroad/GetSAStudentWorkflowService', {
    wsId
  });
  return result;
}

export const saveSANonCourseServiceRecord = (data) => {
  let result = postData('/StudyAbroad/SaveSANonCourseServiceRecord', data);
  return result;
}

export const saveStudyAbroadStudentChannel = (studentId, channelId) => {
  let data = {
    studentId,
    channelId
  };
  let result = getData('/StudyAbroad/SaveStudyAbroadStudentChannel', data);
  return result;
}

export const getStudyAbroadWorkflow = (id) => {
  let result = getData('/StudyAbroad/GetStudyAbroadWorkflow', {
    id: id
  });
  return result;
}

export const saveStudyAbroadWorkflow = (data) => {
  let result = postData('/StudyAbroad/SaveStudyAbroadWorkflow', data);
  return result;
}

export const removeStudyAbroadWorkflow = (id) => {
  let result = getData('/StudyAbroad/RemoveStudyAbroadWorkflow', {
    id: id
  });
  return result;
}

export const changeSAWorkflowServiceItemStartDate = (id, startDate) => {
  let data = {
    id,
    startDate: moment(startDate).format("YYYY-MM-DD HH:mm:SS")
  };

  let result = getData('/StudyAbroad/ChangeSAWorkflowServiceItemStartDate', data);
  return result;
}

export const closeSAWorkflowServiceById = (id, closeDate) => {
  let result = getData('/StudyAbroad/CloseSAWorkflowServiceById', {
    id,
    closeDate
  });
  return result;
}

export const closeSAWorkflowServiceItemById = (id, closeDate) => {
  let result = getData('/StudyAbroad/CloseSAWorkflowServiceItemById', {
    id,
    closeDate
  });
  return result;
}

export const getStudyAbroadPlanServiceList = (channelId) => {
  let data = {
    channelId
  };
  let result = getData('/StudyAbroad/GetStudyAbroadPlanServiceList', data);
  return result;
}

export const saveStudyAbroadPlanServices = (data) => {
  let result = postData('/StudyAbroad/SaveStudyAbroadPlanServices', data);
  return result;
}

export const getAccountByWorkflowId = (studentId, workflowId) => {
  let data = {
    studentId: studentId,
    workflowId: workflowId
  };

  return getData('/StudyAbroad/GetAccountByWorkflowId', data);;
}

export const getSalesQuerySummary = (model) => {
  let data = convertPageModel(model);
  return postData('/StudyAbroad/GetSalesQuerySummary', data);
}

export const getSalesQueryList = (model) => {
  let data = convertPageModel(model);
  return postData('/StudyAbroad/GetSalesQueryList', data);
}

export const getRunningAccountSummary = (model) => {
  let data = convertPageModel(model);
  return postData('/StudyAbroad/GetRunningAccountSummary', data);
}

export const getRunningAccountList = (model) => {
  let data = convertPageModel(model);
  return postData('/StudyAbroad/GetRunningAccountList', data);
}

export const saveStudyAbroadCourses = (workflowServiceItemId, courseIdList, courseHours) => {
  let data = {
    WorkflowServiceItemId: workflowServiceItemId,
    CourseIdList: courseIdList,
    CourseHours: courseHours
  };
  return postData('/StudyAbroad/SaveStudyAbroadCourses', data);
}

export const removeStudyAbroadCourses = (workflowCourseId) => {
  let data = {
    workflowCourseId: workflowCourseId
  };

  return getData('/StudyAbroad/RemoveStudyAbroadCourses', data);;
}

export const changeStudyAbroadCourses = (originalWorkflowCourseId, newCourseId, hours) => {
  if (hours == "") {
    hours = null;
  }
  let data = {
    originalWorkflowCourseId: originalWorkflowCourseId,
    newCourseId: newCourseId,
    hours: hours
  };

  return getData('/StudyAbroad/ChangeStudyAbroadCourses', data);;
}

export const dropStudyAbroadCourse = (workflowCourseId, hour) => {
  let data = {
    WorkflowCourseId: workflowCourseId,
    Hour: hour,
  };
  return postData('/StudyAbroad/DropStudyAbroadCourse', data);
}

export const refundServiceItem = (workflowServiceItemId) => {
  let data = {
    workflowServiceItemId: workflowServiceItemId
  };
  return getData('/StudyAbroad/RefundServiceItem', data);
}

export const updateIsPaymentReceived = (workflowId, isPaymentReceived) => {
  let data = {
    workflowId: workflowId,
    isPaymentReceived: isPaymentReceived
  };
  return getData('/StudyAbroad/UpdateIsPaymentReceived', data);
}

export const getAccountList = (model) => {
  let data = convertPageModel(model);
  return postData('/StudyAbroad/GetAccountList', data);
}

export const getAccountSummaryList = (model) => {
  let data = convertPageModel(model);
  return postData('/StudyAbroad/GetAccountSummaryList', data);
}

export const getStudyAbroadStudentList = (model) => {
  let data = convertPageModel(model);
  return postData('/StudyAbroad/GetStudyAbroadStudentList', data);
}

export const getHomeworkList = (termId, studentId) => {
  return getData('/StudyAbroad/GetHomeworkList', {
    termId: termId,
    studentId: studentId
  });
}

export const getTranscriptList = (termId, studentId) => {
  return getData('/StudyAbroad/GetTranscriptList', {
    termId: termId,
    studentId: studentId
  });
}

export const getScoreData = (studentId, courseId, scoreType) => {
  return getData('/StudyAbroad/GetScoreData', {
    studentId: studentId,
    courseId: courseId,
    scoreType: scoreType
  });
}

export const saveScoreData = (data) => {
  return postData('/StudyAbroad/SaveScoreData', data);
}

//#region Task Assignment
export const getSAEmployees = (roleList, keyword, sortList) => {
  let data = {
    RoleList: roleList,
    Keyword: keyword,
    SortList: sortList
  };
  var result = postData('/StudyAbroad/GetSAEmployees', data);
  return result;
}

export const getSATaskAssignmentStudentList = (model) => {
  let data = convertPageModel(model);
  let result = postData('/StudyAbroad/GetSATaskAssignmentStudentList', data);
  return result;
}

export const saveTaskAssignment = (data) => {
  let result = postData('/StudyAbroad/SaveTaskAssignment', data);
  return result;
}
//#endregion

//#region Studies Related Info
export const getStudyAbroadStudiesRelatedInfo = (studentId) => {
  let data = {
    studentId: studentId
  };

  return getData('/StudyAbroad/GetStudyAbroadStudiesRelatedInfo', data);
}

export const saveStudyAbroadStudiesRelatedInfo = (data) => {
  let result = postData('/StudyAbroad/SaveStudyAbroadStudiesRelatedInfo', data);
  return result;
}
//#endregion

//#region Academic Analysis Report File
export const getStudyAbroadAcademicAnalysisReportFileList = (studentId) => {
  let data = {
    studentId
  };

  return getData('/StudyAbroad/GetStudyAbroadAcademicAnalysisReportFileList', data);
}

export const saveStudyAbroadAcademicAnalysisReportFiles = (data) => {
  let result = postData('/StudyAbroad/SaveStudyAbroadAcademicAnalysisReportFiles', data);
  return result;
}

export const removeStudyAbroadAcademicAnalysisReportFile = (fileId) => {
  let data = {
    fileId
  };

  return getData('/StudyAbroad/RemoveStudyAbroadAcademicAnalysisReportFile', data);;
}
//#endregion

//#region Student Tuition
export const getStudyAbroadStudentTuition = (studentId, termId) => {
  let data = {
    studentId,
    termId
  };

  return getData('/StudyAbroad/GetStudyAbroadStudentTuition', data);
}

export const saveStudyAbroadStudentTuition = (data) => {
  let result = postData('/StudyAbroad/SaveStudyAbroadStudentTuition', data);
  return result;
}

export const saveStudyAbroadStudentTuitionDetail = (data) => {
  let result = postData('/StudyAbroad/SaveStudyAbroadStudentTuitionDetail', data);
  return result;
}

export const removeStudyAbroadStudentTuitionDetail = (id) => {
  let data = {
    id
  };

  return getData('/StudyAbroad/RemoveStudyAbroadStudentTuitionDetail', data);
}

export const changeStudyAbroadStudentTuitionPaid = (id, isPaid) => {
  let data = {
    id,
    isPaid
  };

  return getData('/StudyAbroad/ChangeStudyAbroadStudentTuitionPaid', data);
}

export const exportStudyAboardServices = async () => {
  var result = await getFileData('/StudyAbroad/ExportStudyAboardServices');
  return result;
}

export const uploadExcelForStudyAboardServiceImport = async (form) => {

  var result = await formSend('/Common/Upload', form, "post", false, "blob");
  return result;
}

export const getAllStudyAbroadServicesForTreeSelect = async () => {
  var result = await getData("/StudyAbroad/GetAllStudyAbroadServicesForTreeSelect")
  return result;
}


// WEBPACK FOOTER //
// ./src/service/studyAbroad.service.js